import React, { useEffect, useState } from "react";
import LineChart from "@common/components/LineChart";
import { useChartState } from "../hooks/useChartState";
import { Device } from "@services/devices/types";
import { GraphType } from "@services/monitoring/types";
import { LineChartProps } from "@common/components/LineChart/LineChart";
import { useMeetingChartData } from "./useMeetingChartData";
import { useMeetingAnnotations } from "../hooks/useMeetingAnnotations";

type MeetingLiveChartProps = Required<
  Pick<LineChartProps, "title" | "color">
> & {
  device: Device | undefined;
  graphType: GraphType;
  breadcrumbPage: string;
  start?: number;
  end?: number;
};

const MeetingLiveChart = (props: MeetingLiveChartProps) => {
  const { title, color, device, graphType, start, end, breadcrumbPage } = props;

  const [selectedChartType, setSelectedChartType] = useState(graphType);

  useEffect(() => {
    setSelectedChartType(graphType);
  }, [graphType]);

  const { meetingChartData, startTime, stopTime, updateChartData } =
    useMeetingChartData({
      device,
      start,
      end,
      graphType: selectedChartType,
    });

  const { chartData, yMax, unitMeasurement } = useChartState({
    title,
    device,
    graphType: selectedChartType,
    chartData: meetingChartData,
  });

  const { annotations: meetingAnnotations, refetch: refetchAnnotations } =
    useMeetingAnnotations({
      device,
      start: startTime,
      end: stopTime,
      liveUpdate: false,
      breadcrumbPage,
    });

  const handleRefetch = () => {
    updateChartData();
    refetchAnnotations();
  };

  useEffect(() => {
    handleRefetch();
  }, [selectedChartType]);

  return (
    <LineChart
      title={title}
      color={color}
      chartData={chartData}
      unitMeasurement={unitMeasurement}
      annotations={meetingAnnotations}
      yMax={yMax}
      start={startTime}
      end={stopTime}
      chartType={selectedChartType}
      onRefresh={handleRefetch}
      onToggle={setSelectedChartType}
    />
  );
};

export default MeetingLiveChart;
